import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Table from '../../../common/components/table/simple-table';

const styles = theme => ({
	button: {
		margin: theme.spacing.unit,
		display:'inline-block',
		color:"#FFFFFF"

	},
	closeIcon:{
		position:'absolute',
		top:10,
		right:10
	},
});

const columns = [
	{name:'RowNO',title:'行',width:150},
	{name:'columns',title:'カラム',width:230},
	{name:'description',title:'内容',width:600},
];


class errorDetails extends React.Component {

	handleClose = () => {
		if(this.props.afterCloseFunc) this.props.afterCloseFunc();
	};

	render () {
		const { classes,dataSource,titles } = this.props;

		return (
			<div className="over_rays">
				<div className={classes.closeIcon}>
					<IconButton color={"primary"} className={classes.button} aria-label="CLOSE"
								onClick={this.handleClose}>
						<CloseIcon/>
					</IconButton>
				</div>
				<div className="over_rays_title">{titles}</div>
				<Table
					dataSource={dataSource}
					columns={columns}
				/>
			</div>
		);
	}
}
errorDetails.propTypes = {
	dataSource: PropTypes.array,
	afterCloseFunc:PropTypes.func,
	titles:PropTypes.string

};
errorDetails.defaultProps = {
	dataSource: [],
	titles:"エラー詳細"
};
export default withStyles(styles)(errorDetails);



// WEBPACK FOOTER //
// ./src/routes/upload/components/error_details.js